import React, { useState } from "react";
import { Calendar } from "primereact/calendar";

function CalendarComponent(props) {
 
  const [date, setDate] = useState(null);
  return (
    <Calendar
      value={props.date}
      className={`customDatePicker dateBox w-100 ${props.className === undefined ? 'mb-2 mb-sm-0 me-0 me-sm-2' : props.className}` }
      panelClassName={` customDatePickerPanel`}
      onChange={(e) => {
        setDate(e.value);
        props.change(e.value);
      }}
      dateFormat="dd.mm.yy"
      showIcon
    />
  );
}

export default CalendarComponent;
